import { AfterViewInit, Component, OnInit } from "@angular/core";
import { tap } from "rxjs/operators";
import { ToggleMenuService } from "../core/services/toggle-menu.service";
import { CompaniesService } from "src/app/core/services/companies.service";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { v4 as uuidv4, parse as uuidParse } from "uuid";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"]
})
export class LayoutComponent implements AfterViewInit {
  showMobileMenu = true;
  showButtonMenu = false;
  result: any;
  colors: any;
  test;

  constructor(
    private toggleMenuService: ToggleMenuService,
    private router: Router,
    private companiesService: CompaniesService,
    private activeRouter: ActivatedRoute
  ) {}
  ngOnInit() {
    this.automaticColors();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.automaticColors();
      }
    });
  }

  automaticColors() {
    let id = localStorage.getItem("id");
    if (!id) {
      localStorage.setItem("id", "65");
      id = "65";
    }
    this.test = JSON.parse(localStorage.getItem("currentUser"));

    const response = this.companiesService.getCompanieById(id).subscribe(res => {
      this.result = res;
      let t = JSON.parse(this.result.white_label);
      let y = JSON.parse(t);
      this.colors = JSON.parse(y.color);
      document.documentElement.style.setProperty("--bb-primary", this.colors.cor1);
      document.documentElement.style.setProperty("--bb-primary-light", this.colors.cor1);
      document.documentElement.style.setProperty("--bb-primary-dark", this.colors.cor1);
      document.documentElement.style.setProperty("--bb-secondary", this.colors.cor2);
      document.documentElement.style.setProperty("--bb-secondary-light", this.colors.cor2);
      document.documentElement.style.setProperty("--bb-secondary-dark", this.colors.cor2);
      document.documentElement.style.setProperty("--text-primary", this.colors.text1);
      document.documentElement.style.setProperty("--text-secondary", this.colors.text2);
      document.documentElement.style.setProperty("--text-third", this.colors.text3);
      document.documentElement.style.setProperty("--text-support", this.colors.textS);
    });
  }

  ngAfterViewInit() {
    this.autoToggleMenu();
    document.body.classList.remove("authentication-bg");
    document.body.classList.remove("authentication-bg-pattern");
  }
  onToggleMobileMenu() {
    this.toggleMenuService.toggle();
  }

  private autoToggleMenu() {
    this.toggleMenuService.autoToggleMenu();
    if (this.toggleMenuService.NOT_DESKTOP) {
      this.toggleMenuService.close();
      this.showButtonMenu = true;
    } else {
      this.toggleMenuService.open();
      this.showButtonMenu = false;
    }
    this.toggleMenuService.showMobileMenu$
      .pipe(
        tap(isActive => {
          this.showMobileMenu = isActive;
        })
      )
      .subscribe();
  }
}
